/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMeasurementRequest } from './APIMeasurementRequest';
import {
    APIMeasurementRequestFromJSON,
    APIMeasurementRequestFromJSONTyped,
    APIMeasurementRequestToJSON,
} from './APIMeasurementRequest';
import type { APIHumanReadableDurationRequest } from './APIHumanReadableDurationRequest';
import {
    APIHumanReadableDurationRequestFromJSON,
    APIHumanReadableDurationRequestFromJSONTyped,
    APIHumanReadableDurationRequestToJSON,
} from './APIHumanReadableDurationRequest';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIArticleRequest
 */
export interface APIArticleRequest {
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    hoopsPartId?: string;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIArticleRequest
     */
    weight?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIArticleRequest
     */
    length?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIArticleRequest
     */
    width?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIArticleRequest
     */
    height?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIArticleRequest
     */
    volume?: APIMeasurementRequest | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    barcodeText?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    qualityClass?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    countryOfOrigin?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    description?: string;
    /**
     * 
     * @type {APIHumanReadableDurationRequest}
     * @memberof APIArticleRequest
     */
    leadTime?: APIHumanReadableDurationRequest | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIArticleRequest
     */
    isBomBase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIArticleRequest
     */
    isImportedVersion?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    articleType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    family?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    brand?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    barcodeType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    material: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    variationOf?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    supplier?: string | null;
    /**
     * 
     * @type {Array<string | null>}
     * @memberof APIArticleRequest
     */
    category?: Array<string | null>;
    /**
     * 
     * @type {Array<string | null>}
     * @memberof APIArticleRequest
     */
    properties?: Array<string | null>;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    guestRequest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleRequest
     */
    sharedRequest?: string | null;
}

/**
 * Check if a given object implements the APIArticleRequest interface.
 */
export function instanceOfAPIArticleRequest(value: object): value is APIArticleRequest {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('material' in value) || value['material'] === undefined) return false;
    return true;
}

export function APIArticleRequestFromJSON(json: any): APIArticleRequest {
    return APIArticleRequestFromJSONTyped(json, false);
}

export function APIArticleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'number': json['number'],
        'hoopsPartId': json['hoops_part_id'] == null ? undefined : json['hoops_part_id'],
        'weight': json['weight'] == null ? undefined : APIMeasurementRequestFromJSON(json['weight']),
        'length': json['length'] == null ? undefined : APIMeasurementRequestFromJSON(json['length']),
        'width': json['width'] == null ? undefined : APIMeasurementRequestFromJSON(json['width']),
        'height': json['height'] == null ? undefined : APIMeasurementRequestFromJSON(json['height']),
        'volume': json['volume'] == null ? undefined : APIMeasurementRequestFromJSON(json['volume']),
        'barcodeText': json['barcode_text'] == null ? undefined : json['barcode_text'],
        'qualityClass': json['quality_class'] == null ? undefined : json['quality_class'],
        'countryOfOrigin': json['country_of_origin'] == null ? undefined : json['country_of_origin'],
        'description': json['description'] == null ? undefined : json['description'],
        'leadTime': json['lead_time'] == null ? undefined : APIHumanReadableDurationRequestFromJSON(json['lead_time']),
        'isBomBase': json['is_bom_base'] == null ? undefined : json['is_bom_base'],
        'isImportedVersion': json['is_imported_version'] == null ? undefined : json['is_imported_version'],
        'articleType': json['article_type'] == null ? undefined : json['article_type'],
        'family': json['family'] == null ? undefined : json['family'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'barcodeType': json['barcode_type'] == null ? undefined : json['barcode_type'],
        'material': json['material'],
        'variationOf': json['variation_of'] == null ? undefined : json['variation_of'],
        'supplier': json['supplier'] == null ? undefined : json['supplier'],
        'category': json['category'] == null ? undefined : json['category'],
        'properties': json['properties'] == null ? undefined : json['properties'],
        'guestRequest': json['guest_request'] == null ? undefined : json['guest_request'],
        'sharedRequest': json['shared_request'] == null ? undefined : json['shared_request'],
    };
}

export function APIArticleRequestToJSON(value?: APIArticleRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'number': value['number'],
        'hoops_part_id': value['hoopsPartId'],
        'weight': APIMeasurementRequestToJSON(value['weight']),
        'length': APIMeasurementRequestToJSON(value['length']),
        'width': APIMeasurementRequestToJSON(value['width']),
        'height': APIMeasurementRequestToJSON(value['height']),
        'volume': APIMeasurementRequestToJSON(value['volume']),
        'barcode_text': value['barcodeText'],
        'quality_class': value['qualityClass'],
        'country_of_origin': value['countryOfOrigin'],
        'description': value['description'],
        'lead_time': APIHumanReadableDurationRequestToJSON(value['leadTime']),
        'is_bom_base': value['isBomBase'],
        'is_imported_version': value['isImportedVersion'],
        'article_type': value['articleType'],
        'family': value['family'],
        'brand': value['brand'],
        'barcode_type': value['barcodeType'],
        'material': value['material'],
        'variation_of': value['variationOf'],
        'supplier': value['supplier'],
        'category': value['category'],
        'properties': value['properties'],
        'guest_request': value['guestRequest'],
        'shared_request': value['sharedRequest'],
    };
}

